import { API_CUSTOM_HEADERS, CreateLeadAppraisalChatbotDto, CreateLeadContactChatbotDto } from '@endion/types';
import { callApi, getEndpoint } from '../utils/api.utils';
import { getConversationKeyFromLocalStorage } from '../utils/local-storage';

const ENDPOINT = 'chatbot';

export function leadsSendContact({
  chatbotApiKey,
  payload,
}: {
  chatbotApiKey: string;
  payload: CreateLeadContactChatbotDto;
}) {
  const conversationKey = getConversationKeyFromLocalStorage();
  const headers = new Headers();
  headers.set(API_CUSTOM_HEADERS.X_CHATBOT_API_KEY, chatbotApiKey);

  // At this point we're sure we have a conversation key, but typescript doesn't know that.
  if (conversationKey) {
    headers.set(API_CUSTOM_HEADERS.X_CHAT_CONVERSATION_KEY, conversationKey);
  }

  return callApi<{ data: unknown }>(getEndpoint(`${ENDPOINT}/lead-send-contact`), {
    method: 'post',
    headers,
    body: JSON.stringify(payload),
  });
}

export function leadsSendAppraisal({
  chatbotApiKey,
  payload,
}: {
  chatbotApiKey: string;
  payload: CreateLeadAppraisalChatbotDto;
}) {
  const headers = new Headers();
  const conversationKey = getConversationKeyFromLocalStorage();

  headers.set(API_CUSTOM_HEADERS.X_CHATBOT_API_KEY, chatbotApiKey);

  // At this point we're sure we have a conversation key, but typescript doesn't know that.
  if (conversationKey) {
    headers.set(API_CUSTOM_HEADERS.X_CHAT_CONVERSATION_KEY, conversationKey);
  }

  return callApi<{ data: unknown }>(getEndpoint(`${ENDPOINT}/lead-send-appraisal`), {
    method: 'post',
    headers,
    body: JSON.stringify(payload),
  });
}
